import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import PredictBeforePartner from "@/components/landing/PredictBeforePartner";
import BrandTicker from "@/components/landing/BrandTicker";
import SocialProof from "@/components/landing/SocialProof";
import WhatWeDo from "@/components/landing/WhatWeDo";
import TypesOfBrands from "@/components/landing/TypesOfBrands";
import HowWeDoIt from "@/components/landing/HowWeDoIt";
import Pricing from "@/components/landing/Pricing";
import ContentShowcase from "@/components/landing/ContentShowcase";
import CaseStudy from "@/components/landing/CaseStudy";
import Testimonials from "@/components/landing/Testimonials";
import About from "@/components/landing/About";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

export default function Landing() {
    const { hash } = useLocation();

    useEffect(() => {
        if (!hash) return;
        const id = hash.replace("#", "");
        const t = setTimeout(() => {
            const el = document.getElementById(id);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 120);
        return () => clearTimeout(t);
    }, [hash]);

    return (
        <main className="relative overflow-x-clip">
            <Nav />
            <Hero />
            <PredictBeforePartner />
            <BrandTicker />
            <SocialProof />
            <WhatWeDo />
            <TypesOfBrands />
            <HowWeDoIt />
            <Pricing />
            <ContentShowcase />
            <CaseStudy />
            <Testimonials />
            <About />
            <FAQ />
            <FinalCTA />
            <Footer />
        </main>
    );
}
